import { render, staticRenderFns } from "./CutAdd.vue?vue&type=template&id=1b22bffd&scoped=true&"
import script from "./CutAdd.vue?vue&type=script&lang=js&"
export * from "./CutAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b22bffd",
  null
  
)

export default component.exports